const Component = () => import('./MisfitsPerks');

export { Component };
